<template>
    <v-dialog max-width="720px" v-model="getModalCadastroPortadorFinanceiro">
        <v-card outlined :loading="$store.getters.getOverlay">
            <Alert />
            <v-card-title>
                Cadastro de Portador
            </v-card-title>
            <form @submit.prevent="salvar" class="px-3">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field outlined dense class="mr-2 ml-2" v-model="getPortadorFinanceiro.nome" label="Nome" required></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="default" @click="setModalCadastroPortadorFinanceiro(false)" outlined>Voltar</v-btn>
                    <v-btn color="primary" v-if="getPortadorFinanceiro.id" @click="cadastrarPortadorFinanceiro" outlined>Novo</v-btn>
                    <v-btn color="error"  v-if="getPortadorFinanceiro.id" @click="setModalExcluirPortadorFinanceiro(true)" outlined>Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" type="submit" outlined>Salvar</v-btn>
                </v-card-actions>
            </form>
        </v-card>
        
        <ModalExcluir />
    </v-dialog>
</template>

<script>
    import ModalExcluir from "@/pages/financeiro/grupo/ModalExcluir"
    import { mapGetters, mapActions } from 'vuex'
    export default {
        components: {
            ModalExcluir
        },
        computed: {
            ...mapGetters([
            'getPortadorFinanceiro',
            'getModalCadastroPortadorFinanceiro',
            ])
        },
        
        methods: {
            ...mapActions([
            'setModalCadastroPortadorFinanceiro',
            'setModalExcluirPortadorFinanceiro',
            'cadastrarPortadorFinanceiro',
            'salvarPortadorFinanceiro',
            'atualizarPortadorFinanceiro',
            ]),
            salvar(){
                if(this.getPortadorFinanceiro.id){
                    this.atualizarPortadorFinanceiro(this.getPortadorFinanceiro)
                }else{
                    this.salvarPortadorFinanceiro(this.getPortadorFinanceiro)
                }
            },
        },
        created(){
        }
    }
</script>